export const STATUS_WIDGET_REFRESH_INTERVAL_MS = 5 * 60 * 1000;
